<template>
    <v-tabs v-model="tab" ref="tabs" centered center-active show-arrows dense>
        <v-tab
            v-for="item in items"
            :key="item.to"
            :to="item.to"
            class="font-weight-black caption"
            :class="tabClass(item)"
        >
            {{ item.text }}
            <v-badge
                class="ml-2"
                color="info"
                v-if="showRegistrationsBadge(item)"
            >
                <template v-slot:badge>
                    {{ nrTodayRegistrations }}
                </template>
            </v-badge>
            <v-badge class="ml-2" color="info" v-if="showDriversBadge(item)">
                <template v-slot:badge>
                    {{ nrNotSetDrivers }}
                </template>
            </v-badge>
        </v-tab>
    </v-tabs>
</template>
<script>
export default {
    data: () => ({
        tab: null,
    }),
    methods: {
        tabClass(item) {
            return item.to === "/registrations" ||
                item.to === "/driver-overview"
                ? "px-8"
                : "";
        },
        showRegistrationsBadge(item) {
            return (
                item.to === "/registrations" && this.nrTodayRegistrations > 0
            );
        },
        showDriversBadge(item) {
            return item.to === "/driver-overview" && this.nrNotSetDrivers > 0;
        },
    },
    computed: {
        items() {
            return [
                {
                    to: "/home",
                    text: this.$t("message.Home"),
                    visible: this.$can("read", "home"),
                },
                {
                    to: "/company",
                    text: this.$t("message.Company"),
                    visible: this.$can("read", "company"),
                },
                {
                    to: "/users",
                    text: this.$t("message.Users"),
                    visible: this.$can("read", "users"),
                },
                {
                    to: "/registrations",
                    text: this.$t("message.Registrations"),
                    visible: this.$can("read", "registrations"),
                },
                {
                    to: "/registrations-archive",
                    text: this.$t("message.Registrations_Archive"),
                    visible: this.$can("read", "registrationsarchive"),
                },
                {
                    to: "/recurring-registrations",
                    text: this.$t("message.Recurring_Registrations"),
                    visible: this.$can("read", "recurringregistrations"),
                },
                {
                    to: "/driver-overview",
                    text: this.$t("message.Driver_Overview"),
                    visible: this.$can("read", "driveroverview"),
                },
                {
                    to: "/driver-registration",
                    text: this.$t("message.Driver_Registration"),
                    visible: this.$can("read", "driverregistration"),
                },
            ].filter(item => item.visible);
        },
        nrTodayRegistrations() {
            return this.$store.getters.getRegistrations.filter(
                obj => obj.status === "2 today"
            ).length;
        },
        nrNotSetDrivers() {
            return this.$store.getters.getAllDrivers.filter(
                driver => driver.expected_status === 0
            ).length;
        },
    },
    watch: {
        "$i18n.locale": function () {
            this.$refs.tabs.onResize();
        },
        nrTodayRegistrations() {
            this.$refs.tabs.onResize();
        },
        nrNotSetDrivers() {
            this.$refs.tabs.onResize();
        },
    },
};
</script>
